import { FiltersModalContextState } from 'components/FiltersModalProvider/FiltersModalProvider';
import { FiltersContextState } from 'components/FiltersProvider/FiltersProvider';
import { Filter, ListFilterOption } from 'lib/apiClient';
import { ReactNode } from 'react';

export enum Variant {
	Base = 'base',
	Home = 'home',
}

export enum CalendarType {
	Months = 'months',
	Dates = 'dates',
}

export enum CruiseVoyageType {
	Ocean = 'OCEAN',
	River = 'RIVER',
}

export enum CustomFilterSectionType {
	Default = 'DEFAULT',
	River = 'RIVER',
}

export type ScrollingContainer = 'html' | 'body';

/**
 * Props for the CruiseSearchWidget component.
 *
 * @prop {string} containerId - The ID of the container element to render the component within.
 * @prop {string[]} navigationFilters - The duration of the cruise in days.
 * @prop {Variant} variant - The widget variant to use.
 * @prop {string[]} calendarTypes - The types of calendar to display for date or date range filters.
 * @prop {Record<string, Filter>} filters - All the filters available to display in component.
 * @prop {boolean} enableDestinationPort - Whether to enable the port filter as part of the destination filter section.
 * @prop {boolean} enableDestinationPortSearch - Whether to enable the search functionality for the port filter.
 * @prop {boolean} isSticky - Whether the component is sticky at the top of the page when scrolling.
 * @prop {FilterDropdownConfig[]} customElements - List of custom elements to be rendered as filter dropdowns.
 * @prop {boolean} enableUniqueFilters - Whether to enable the unique filter pills feature.
 * @prop {boolean} enableNumberOfGuests - Whether to enable the number of guests filter.
 * @prop {ScrollingContainer} scrollingContainer - The scrolling container for the filters modal.
 */
export interface CruiseSearchWidgetProps {
	containerId?: string;
	navigationFilters: string[];
	variant: Variant;
	calendarTypes?: CalendarType[];
	filters?: Record<string, Filter>;
	enableDestinationPort?: boolean;
	enableDestinationPortSearch?: boolean;
	isSticky?: boolean;
	isPinned?: boolean;
	customElements?: FilterDropdownConfig[];
	enableUniqueFilters?: boolean;
	enableNumberOfGuests?: boolean;
	scrollingContainer?: ScrollingContainer;
}

export interface CustomFilterSectionConfig {
	section: CustomFilterSectionType;
	labelDictionaryKey: string;
}

export interface CustomFilterContent {
	filterOptions: Array<ListFilterOption>;
	customFilterLabel: string;
}
export interface CustomFilterConfig {
	container: string;
	labelDictionaryKey?: string;
	sections?: Array<CustomFilterSectionConfig>;
}

export interface FilterTabOption {
	filterOwner: string;
	value: string;
	dictionaryLabel: string;
	testId: string;
	dictionarySubLabel?: string;
}

export type CustomElementProps = Partial<FiltersContextState> & Partial<FiltersModalContextState>;

export interface FilterDropdownConfig {
	label: string;
	key: string;
	tabs?: Array<FilterTabOption>;
	desktopTestId: string;
	mobileTestId?: string;
	dictionaryLabel: string;
	amount: number;
	isFullColor: boolean;
	isSelected: boolean;
	dictionarySubLabel: string;
	dictionaryTopLabel?: string;
	dictionaryModalLabel?: string;
	customElement?: (props: CustomElementProps) => ReactNode;
	skipModal?: boolean;
	customFilterConfig?: CustomFilterConfig;
}
